import dayjs from "dayjs";
import { GiftcardsIcon } from "src/assets/Icons";
import i18n from "src/i18n";
import { formatDate, formatNumber } from "src/utility";
import type { DataMap } from "../../../OrderCard/constants";
import type { UserOrderItem } from "../../../../constants";

type GiftcardOrderItem = UserOrderItem<"GiftCards">;

const GIFT_CARDS_ICON = (
  <div className="rounded-xl bg-background-minimal p-2" aria-hidden="true">
    <GiftcardsIcon className="text-font-active" aria-hidden="true" />
  </div>
);

const GIFT_CARD_DATA_MAP = {
  referenceNumber: {
    get label() {
      return i18n.t("UserHistory.ordersList.referenceNumber");
    },
  },
  orderedAt: {
    get label() {
      return i18n.t("UserHistory.ordersList.purchaseDate");
    },
    value: (val: string) => formatDate(val, "YYYY-MM-DD, hh:mm A"),
  },
  points: {
    get label() {
      return i18n.t("UserHistory.ordersList.pointsUsed");
    },
    value: (val: number) => (
      <span className="text-font-active">
        {formatNumber(val)}
        {i18n.t("UserHistory.ordersList.pts")}
      </span>
    ),
  },
  provider: {
    get label() {
      return i18n.t("UserHistory.ordersList.provider");
    },
  },
  cardCode: {
    get label() {
      return i18n.t("UserHistory.ordersList.cardCode");
    },
    value: (val) => (val ? val : "-"),
  },
  cardExpiryDate: {
    get label() {
      return i18n.t("UserHistory.ordersList.cardExpiryDate");
    },
    value: (val: string) => dayjs(val).format("DD/MM/YYYY"),
  },
} satisfies DataMap;

export type { GiftcardOrderItem };
export { GIFT_CARDS_ICON, GIFT_CARD_DATA_MAP };
